import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Breadcrumb from "../../components/breadcrumb/index";
import { Country, State, City } from "country-state-city";
import { LoadScript, Autocomplete } from "@react-google-maps/api";
import Layouts from "../../layouts/layouts";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";

export default function Create_lease() {
  const title = "Add Lease";
  const [formData, setFormData] = useState({
    id_vehicle: [],
    leasing_partner: "",
    leasing_amount: "",
    status: "Active",
    onboardingDate: "",
    lastDate: "",
    dueDate: "",
    comments: "",
    email_id: "",
    tenure_years: "",
    phone_number: "",
  });

  const [autocomplete, setAutocomplete] = useState(null);
  const [errors, setErrors] = useState({});
  const [selectedVehicle, setSelectedVehicle] = useState("");
  const [vehicles, setVehicles] = useState([]); // Store fetched vehicles
  const [leasingPartners, setLeasingPartners] = useState([]);

  const navigate = useNavigate();

  const brad = [{ name: "Home" }, { name: title }];

  const onChangeHandler = (event) => {
    const { name, value } = event.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const onLoad = (autoComp) => {
    setAutocomplete(autoComp);
  };

  useEffect(() => {
    const fetchLeases = async () => {
      try {
        const token = localStorage.getItem("token");

        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v3/leases`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        if (response.status === 200) {
          const partnerMap = new Map();

          response.data.leases.forEach((lease) => {
            if (
              lease.leasing_partner &&
              !partnerMap.has(lease.leasing_partner)
            ) {
              partnerMap.set(lease.leasing_partner, {
                value: lease.leasing_partner,
                label: lease.leasing_partner,
                email: lease.email_id || "",
                phone: lease.phone_number || "",
              });
            }
          });

          setLeasingPartners([...partnerMap.values()]);
        }
      } catch (err) {
        console.error(err);
      }
    };

    fetchLeases();
  }, []);

  useEffect(() => {
    const fetchVehicles = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          console.error("No token found");
          return;
        }

        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v1/vehicles`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        if (response.status === 200 && response.data.vehicles) {
          setVehicles(response.data.vehicles); // Update vehicles state
        } else {
          console.error("No vehicles found in the response.");
          setVehicles([]);
        }
      } catch (error) {
        console.error("Error fetching vehicles:", error);
        setVehicles([]); // Handle errors
      }
    };

    fetchVehicles();
  }, []);

  // const handleVehicleChange = (selectedOptions) => {
  //   setFormData((prevFormData) => ({
  //     ...prevFormData,
  //     id_vehicle: selectedOptions
  //       ? selectedOptions.map((option) => option.value)
  //       : [],
  //   }));
  // };
  const handleVehicleChange = (selectedOptions) => {
    const vehicleIds = selectedOptions
      ? selectedOptions.map((option) => option.value)
      : [];

    setFormData((prevFormData) => ({
      ...prevFormData,
      id_vehicle: vehicleIds,
    }));
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.id_vehicle) newErrors.id_vehicle = "Vehicle is required.";
    if (!formData.onboardingDate)
      newErrors.from = "OnBoarding date is required.";
    if (!formData.leasing_partner)
      newErrors.leasing_partner = "Leasing Partner is required.";
    if (!formData.leasing_amount)
      newErrors.leasing_amount = "Leasing Amount is required.";
    if (!formData.tenure_years)
      newErrors.tenure_years = "Tenure Years is required.";
    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const onSubmitHandler = async (event) => {
    event.preventDefault();

    if (!validateForm()) {
      return;
    }

    const token = localStorage.getItem("token");
    if (!token) {
      console.error("No token found");
      return;
    }

    const data = new FormData();
    if (Array.isArray(formData.id_vehicle)) {
      formData.id_vehicle.forEach((vehicleId) => {
        data.append("id_vehicle[]", vehicleId);
      });
    }

    if (formData.leasing_partner) {
      data.append("leasing_partner", formData.leasing_partner);
    }
    data.append("status", formData.status);
    data.append("onboardingDate", formData.onboardingDate);
    data.append("lastDate", formData.lastDate);
    data.append("dueDate", formData.dueDate);
    data.append("email_id", formData.email_id);
    data.append("comments", formData.comments);
    data.append("leasing_amount", formData.leasing_amount);
    data.append("tenure_years", formData.tenure_years);
    data.append("phone_number", formData.phone_number);

    for (let [key, value] of data.entries()) {
      console.log(`${key}: ${value}`);
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/v3/lease/new`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      console.log("Response data:", response.data);

      if (response.status === 201) {
        navigate("/lease");
      } else {
        console.error("Submission failed:", response.statusText);
      }
    } catch (error) {
      //   console.error("Error:", error);
    }
  };

  return (
    <>
      <Layouts />
      <div className="container-fluid">
        <Breadcrumb title={title} brad={brad} />
        <form
          className="card"
          style={{ borderTop: "2px solid #4723d9" }}
          onSubmit={onSubmitHandler}
        >
          <div className="card-header d-flex justify-content-between border-bottom pb-1">
            <div className="">{title}</div>
            <div className="btn btn-info btn-sm" onClick={() => navigate(-1)}>
              Back
            </div>
          </div>
          <div className="card-body">
            <div className="row justify-content-center">
              <div className="col-md-6 mt-3">
                <label htmlFor="id_vehicle">
                  <b>Vehicle* </b>
                </label>
                <Select
                  name="id_vehicle"
                  options={vehicles.map((vehicle) => ({
                    value: vehicle._id,
                    label: `${vehicle.numberplate}`,
                  }))}
                  isMulti
                  onChange={handleVehicleChange}
                  className={`basic-multi-select ${
                    errors.id_vehicle ? "is-invalid" : ""
                  }`}
                  classNamePrefix="select"
                />
                {errors.id_vehicle && (
                  <p className="text-danger">{errors.id_vehicle}</p>
                )}
              </div>

              <div className="col-md-6 mt-3">
                <label htmlFor="leasing_partner">
                  <b>Leasing Partner *</b>
                </label>

                <CreatableSelect
                  options={leasingPartners}
                  placeholder="Select or Add Leasing Partner"
                  value={
                    formData.leasing_partner
                      ? {
                          value: formData.leasing_partner,
                          label: formData.leasing_partner,
                        }
                      : null
                  }
                  onChange={(option) => {
                    setFormData((prev) => ({
                      ...prev,
                      leasing_partner: option?.value || "",
                      email_id: option?.email || "",
                      phone_number: option?.phone || "",
                    }));
                  }}
                  onCreateOption={(inputValue) => {
                    const newPartner = {
                      value: inputValue,
                      label: inputValue,
                      email: "",
                      phone: "",
                    };

                    setLeasingPartners((prev) => [...prev, newPartner]);

                    setFormData((prev) => ({
                      ...prev,
                      leasing_partner: inputValue,
                      email_id: "",
                      phone_number: "",
                    }));
                  }}
                />
                {errors.leasing_partner && (
                  <small className="text-danger">
                    {errors.leasing_partner}
                  </small>
                )}
              </div>

              <div className="col-md-6 mt-3">
                <label htmlFor="email_id">
                  <b>Leasing Partner Email </b>
                </label>

                <input
                  type="email"
                  name="email_id"
                  className="form-control"
                  value={formData.email_id}
                  onChange={onChangeHandler}
                />
              </div>
              <div className="col-md-6 mt-3">
                <label htmlFor="phone_number">
                  <b>Phone Number </b>
                </label>

                <input
                  type="text"
                  name="phone_number"
                  className="form-control"
                  value={formData.phone_number}
                  onChange={onChangeHandler}
                />
              </div>

              <div className="col-md-6 mt-3">
                <label htmlFor="leasing_amount">
                  <b>Leasing Amount </b>
                </label>
                <input
                  type="number"
                  name="leasing_amount"
                  placeholder="leasing_amount of Vehicle"
                  className="form-control"
                  value={formData.leasing_amount}
                  onChange={onChangeHandler}
                />
              </div>
              <div className="col-md-6 mt-3">
                <label htmlFor="tenure_years ">
                  <b>Tenure Years * </b>
                </label>
                <input
                  type="number"
                  name="tenure_years"
                  placeholder="Tenure Years of Vehicle"
                  className="form-control"
                  value={formData.tenure_years}
                  onChange={onChangeHandler}
                />
              </div>
              <div className="col-md-6 mt-3">
                <label htmlFor="to">
                  <b>On-Boarding Date *</b>
                </label>
                <input
                  type="date"
                  name="onboardingDate"
                  className="form-control"
                  value={formData.onboardingDate}
                  onChange={onChangeHandler}
                />
              </div>

              <div className="col-md-6 mt-3">
                <label htmlFor="to">
                  <b>Last Date </b>
                </label>
                <input
                  type="date"
                  name="lastDate"
                  className="form-control"
                  value={formData.lastDate}
                  onChange={onChangeHandler}
                />
              </div>

              <div className="col-md-6 mt-3">
                <label htmlFor="status">
                  <b>Status *</b>
                </label>
                <select
                  name="status"
                  className="form-control"
                  value={formData.status}
                  onChange={onChangeHandler}
                >
                  <option value="Active">Active</option>
                  <option value="Inactive">Inactive</option>
                </select>
                {errors.status && (
                  <p className="text-danger">{errors.status}</p>
                )}
              </div>

              <div className="col-md-6 mt-3">
                <label htmlFor="to">
                  <b>Due Date </b>
                </label>
                <input
                  type="date"
                  name="dueDate"
                  className="form-control"
                  value={formData.dueDate}
                  onChange={onChangeHandler}
                />
              </div>

              <div className="col-md-6 mt-3">
                <label htmlFor="comments">
                  <b>Comments *</b>
                </label>
                <input
                  type="text"
                  name="comments"
                  placeholder="comments"
                  className="form-control"
                  value={formData.comments}
                  onChange={onChangeHandler}
                />
              </div>

              <div className="col-md-6 mt-3"></div>
            </div>
            <button type="submit" className="btn btn-primary btn-sm mt-3">
              Add Lease
            </button>
          </div>
        </form>
      </div>
    </>
  );
}
